import Vue from "vue";
import Vuetify from "vuetify";
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: "#0a1e8c",
        accent: colors.blue.accent2,
        secondary: colors.grey.lighten1,
        info: colors.blue.lighten1,
        warning: colors.amber.darken2,
        error: colors.red.accent4,
        success: colors.green.lighten2,
        lotojr_colorPrimary: "#0a1e8c",
        lotojr_colorPrimaryShade: "#4c5aa7",
        lotojr_colorSecondary: "#e4e4e4",
        lotojr_colorAccent: "#c8414b",
        lotojr_colorAccentTint: "#e6b4be",
        lotojr_colorAccentShade: "#c8323c",
        lotojr_colorFonts: "#848484",
      },
      light: {
        primary: "#0a1e8c",
        accent: colors.blue.accent2,
        secondary: colors.grey.lighten1,
        info: colors.blue.lighten1,
        warning: colors.amber.darken2,
        error: colors.red.accent4,
        success: colors.green.lighten2,
        inobram_green_light: "#008e43",
        inobram_green: "#007a43",
        inobram_green_dark: "#00502e",
        lotojr_colorPrimary: "#0a1e8c",
        lotojr_numberDisable: "#adc0c4",
        lotojr_colorPrimaryShade: "#4c5aa7",
        lotojr_colorSecondary: "#e4e4e4",
        lotojr_colorAccent: "#c8414b",
        lotojr_colorAccentTint: "#e6b4be",
        lotojr_colorAccentShade: "#c8323c",
        lotojr_colorFonts: "#848484",
      },
    },
  },
});
